import accountingAccountingNL from './messages/accounting/accounting.json';
import accountingChargeNL from './messages/accounting/charge.json';
import accountingReportingNL from './messages/accounting/reporting.json';
import accountingStatementNL from './messages/accounting/statement.json';
import agencyRatesNL from './messages/agencyRates.json';
import communicationsNL from './messages/communications.json';
import contactNL from './messages/contact.json';
import enumsNL from './messages/enums.json';
import foldersNL from './messages/folders.json';
import leaseAddLeaseNL from './messages/lease/addLease.json';
import leaseDetailNL from './messages/lease/detail.json';
import leaseLeaseNL from './messages/lease/lease.json';
import remainingMessagesNL from './messages/messages.json';
import myCompanyNL from './messages/myCompany.json';
import paymentsNL from './messages/payments.json';
import rentalUnitNL from './messages/rentalUnit.json';
import settingsNL from './messages/settings.json';
import templatesNL from './messages/templates.json';
import transactionsNL from './messages/transactions.json';

export const BackendMessagesNL = {
  accounting: {
    statement: accountingStatementNL,
    reporting: accountingReportingNL,
    charge: accountingChargeNL,
    ...accountingAccountingNL,
  },
  agencyRates: agencyRatesNL,
  communications: communicationsNL,
  contact: contactNL,
  enums: enumsNL,
  folders: foldersNL,
  lease: {
    ...leaseLeaseNL,
    detail: leaseDetailNL,
    addLease: leaseAddLeaseNL,
  },
  myCompany: myCompanyNL,
  rentalUnit: rentalUnitNL,
  settings: settingsNL,
  templates: templatesNL,
  payments: paymentsNL,
  transactions: transactionsNL,
  ...remainingMessagesNL,
};
